import {
    FETCH_ENDPOINTS,
    FETCH_ENDPOINT_SUCCESS,
    FETCH_ENDPOINT_FAILURE,
    FETCH_PROGRAMS,
    FETCH_SOURCES,
    FETCH_RESOURCES,

  } from "../../constants/action";
  
  export const fetchEndpoints = (data) => ({
    type: FETCH_ENDPOINTS,
    payload: data,
  });

  export const fetchPrograms = (data) => ({
    type: FETCH_PROGRAMS,
    payload: data,
  })

  export const fetchEndpointSuccess = (data) => ({
    type: FETCH_ENDPOINT_SUCCESS,
    payload: data,
  });
  
  export const fetchEndpointFailure = (error) => ({
    type: FETCH_ENDPOINT_FAILURE,
    payload: error,
  });
  